// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_dbR","cls2":"Search-cls2_SsQ Search-cls1_dbR"};